import { differenceInYears } from 'date-fns/differenceInYears';
import { parseISO } from 'date-fns/parseISO';
import i18n from 'src/utils/translate';

export const getEthnicityList = (countryCode: 'GB' | 'US' | string = '') => {
  const ethnicityList = {
    'GB': [
      { value: 'white', label: i18n.t('White') },
      { value: 'asian', label: i18n.t('Asian / Asian British') },
      { value: 'black', label: i18n.t('Black / African / Caribbean / Black British') },
    ],
    'US': [
      { value: 'white', label: i18n.t('White') },
      { value: 'latino', label: i18n.t('Hispanic / Latino / Spanish') },
      { value: 'black', label: i18n.t('Black / African American') },
      { value: 'asian', label: i18n.t('Asian') },
      { value: 'indian', label: i18n.t('American Indian / Alaska Native') },
      { value: 'mid-eastern', label: i18n.t('Middle Eastern / North African') },
      { value: 'hawaiians', label: i18n.t('Native Hawaiians / Other Pacific Islanders') },
    ],
    DEFAULT: [
      { value: 'white', label: i18n.t('White / Caucasian') },
      { value: 'latino', label: i18n.t('Latino / Hispanic') },
      { value: 'black', label: i18n.t('Black / African / Caribbean') },
      { value: 'south-asian', label: i18n.t('South Asian') },
      { value: 'east-asian', label: i18n.t('East Asian ') },
      { value: 'mid-eastern', label: i18n.t('Middle Eastern') },
    ],
  };

  const list = countryCode === 'GB' || countryCode === 'US'
    ? ethnicityList[countryCode]
    : ethnicityList.DEFAULT;
  return [
    ...list,
    { value: 'mixed', label: i18n.t('Mixed / Multiple ethnic groups') },
    { value: 'other', label: i18n.t('Other ethnic group') },
    { value: 'none', label: i18n.t('Prefer not to say') },
  ];
};

export enum Gender {
  woman = 'woman',
  man = 'man',
  nonBinary = 'non-binary',
  selfDescribe = 'self-describe',
  none = 'none',
}

const genderOptions_OLD = [
  { value: 'female', label: 'Female' },
  { value: 'male', label: 'Male' },
  { value: 'other', label: 'Other' },
];
const genderOptions = [
  { value: Gender.woman, label: 'Woman' },
  { value: Gender.man, label: 'Man' },
  { value: Gender.nonBinary, label: 'Non-binary' },
  { value: Gender.selfDescribe, label: 'Prefer to self-describe' },
  { value: Gender.none, label: 'Prefer not to say' },
];

// the gender value can be either one of the Gender keys then we display the label, otherwise it's a self-description we display the value
export function getGenderLabel(value: Gender) {
  return [...genderOptions, ...genderOptions_OLD].find((option) => option.value === value)?.label ?? value;
}

export function useGenderOptions(gender: string | null): { genderOptions: { value: string, label: string, isDisabled?: boolean }[], isOldOption: boolean } {
  const oldOption = genderOptions_OLD.find((option) => option.value === gender);
  if (oldOption) {
    return { genderOptions: [{ ...oldOption, isDisabled: true }, ...genderOptions], isOldOption: true };
  }
  return { genderOptions, isOldOption: false };
}

export function isUnder18YearsOld(dateOfBirth?: string | null) {
  if (!dateOfBirth) return false;
  return differenceInYears(new Date(), parseISO(dateOfBirth)) < 18;
}
